import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmbedMethodTab = ({ 
  method, 
  code, 
  language = 'javascript',
  description,
  features = []
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard?.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const getLanguageColor = () => {
    switch (language) {
      case 'javascript':
        return 'text-yellow-500';
      case 'html':
        return 'text-orange-500';
      case 'jsx':
        return 'text-blue-500';
      case 'php':
        return 'text-purple-500';
      default:
        return 'text-muted-foreground';
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div>
          <h3 className="text-lg font-heading font-semibold text-foreground">
            {method}
          </h3>
          <p className="text-sm text-muted-foreground mt-1">
            {description}
          </p>
        </div>
        <Button
          variant="outline"
          size="default"
          iconName={copied ? 'Check' : 'Copy'}
          iconPosition="left"
          onClick={handleCopy}
          className="sm:flex-shrink-0"
        >
          {copied ? 'Copied!' : 'Copy Code'}
        </Button>
      </div>
      {features?.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {features?.map((feature, index) => (
            <div
              key={index}
              className="flex items-center gap-1.5 px-3 py-1.5 bg-primary/10 text-primary rounded-md text-xs font-medium"
            >
              <Icon name="CheckCircle2" size={14} />
              <span>{feature}</span>
            </div>
          ))}
        </div>
      )}
      <div className="relative bg-card border border-border rounded-md overflow-hidden">
        <div className="flex items-center justify-between px-4 py-2 bg-muted border-b border-border">
          <div className="flex items-center gap-2">
            <Icon name="Code2" size={16} color="var(--color-muted-foreground)" />
            <span className={`text-xs font-mono font-medium ${getLanguageColor()}`}>
              {language?.toUpperCase()}
            </span>
          </div>
          <button
            onClick={handleCopy}
            className="p-1.5 rounded hover:bg-background transition-smooth"
            aria-label="Copy code"
          >
            <Icon 
              name={copied ? 'Check' : 'Copy'} 
              size={14} 
              color="var(--color-muted-foreground)" 
            />
          </button>
        </div>

        <div className="p-4 overflow-x-auto scrollbar-custom">
          <pre className="text-sm font-mono text-foreground whitespace-pre">
            <code>{code}</code>
          </pre>
        </div>
      </div>
    </div>
  );
};

export default EmbedMethodTab;